import { Injectable } from '@angular/core'
import { SmODataConfiguration } from '@exchange/services/core/odata'
import { IModelBase } from 'common-components'
import { HttpClient } from '@angular/common/http'
import { ODataService } from 'common-services'

export interface IProcedureCodeset extends IModelBase {
  Name: string
  Description: string
  ActiveOnDateTime: Date
  ExpiresOnDateTime: Date
}

@Injectable()
export class ProcedureCodesetODataService extends ODataService<IProcedureCodeset> {
  constructor(
    protected http: HttpClient,
    protected config: SmODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'RefProcedureCodeSets'
  }
}
